import { decode64 } from '../base64';

export function extractStringFromRandomLink(link: string) {
  const [encodedEmail] = link.split('-');
  try {
    return decode64(encodedEmail);
  } catch {
    return '';
  }
}
